import set from 'date-fns/set'
import parseISO from 'date-fns/parseISO'
import {
  advancedOrder,
  sortFolderDefault,
  sortFolderEnum,
} from 'enum/folder.enum'
import { IFolderSortSettings } from 'models/folder.model'
import { ICourseModel } from 'models/course.model'
import { MonitoringStatus } from 'enum/monitoring-status.enum'
import sortArray from 'helpers/sortArray'
import { ILessonModel } from 'models/lesson.model'

const advance = [
  MonitoringStatus.InProgress,
  MonitoringStatus.Pending,
  MonitoringStatus.Finish,
]

type CustomOrders = {
  [P in keyof ICourseModel]?: ICourseModel[P][]
}

export const orderCourses = (
  courses: ICourseModel[],
  settings?: Partial<IFolderSortSettings>
) => {
  const { fields } = settings || {}
  if (!fields) return courses
  const fieldsSorted = [...fields].sort((a, b) => {
    if (a.attribute === advancedOrder) return -1
    if (b.attribute === advancedOrder) return 1
    return 0
  })

  const keys = fieldsSorted.map(({ attribute }) => attribute)

  const advancedOrderField = fields.find(
    ({ attribute }) => attribute === advancedOrder
  )

  const customOrders: CustomOrders = {
    advance,
  }

  const order: string[] = []
  for (const { attribute, direction } of fieldsSorted) {
    const customOrder = customOrders[attribute]
    const newOrder = customOrder ? attribute : direction || sortFolderDefault
    if (newOrder) order.push(newOrder)
    if (customOrder && direction === sortFolderEnum.desc)
      customOrders[attribute] = [...customOrder].reverse()
  }

  let array = courses
  if (
    fieldsSorted.length === 1 &&
    advancedOrderField &&
    advancedOrderField.direction === sortFolderEnum.desc
  )
    array = [...array].reverse()

  return sortArray(array, {
    by: keys,
    order,
    customOrders,
    maps: {
      name: (value) => value.toLowerCase(),
      createdAt: (value) => {
        try {
          const newDate = set(parseISO(value), {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          })
          return newDate.getTime()
        } catch (error) {
          return value
        }
      },
    },
    computed: {
      [advancedOrder]: (course) => course.order,
    },
  })
}

export const orderLessons = (lessons: ILessonModel[]) =>
  lessons.sort((a, b) => a.order - b.order)
